import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// helpers/constants
import * as G from '../../helpers';
// report-common
import { getReportReducers } from '../../report-common';
// feature equipment-service-invoice
import * as A from './actions';
//////////////////////////////////////////////////

const {
  selectItem,
  setReports,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers({});

const getConfigsByNamesSuccess = (state, configs) => P.$set('branchConfigs', configs, state);

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.setTableTitleSort]: G.setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.setTableTitleFilter]: G.setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.getConfigsByNamesSuccess]: getConfigsByNamesSuccess,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
}, initialState);
